import React from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';
import { Button } from '../UI';

const NoPoolContainer = styled.div`
  width: 100%;
  margin: 20px auto;
  padding: 20px;
  .no_pool_component {
    width: 50%;
    margin: auto;
    text-align: center;
    h1 {
      font-size: 38px;
      font-weight: 700;
      margin: 0;
      padding: 0;
    }
    p {
      color: #000000;
      opacity: 0.45;
      font-size: 19px;
      font-weight: 600;
      padding: 0;
      margin: 10px;
      @media only screen and (max-width: 768px) {
        margin: 0;
      }
    }
    button {
      margin: 20px auto;
      padding: 13px 20px;
      font-size: 18px;
      font-weight: 600;
      border-radius: 11px;
    }
    @media only screen and (max-width: 768px) {
      width: auto;
    }
  }
`;

const CreatePoolModal = styled.div`
  width: 100%;
  height: 320px;
  padding: 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  h1 {
    width: 100%;
    text-align: center;
    font-size: 30px;
    margin: 0;
  }
  button {
    padding: 10px 10px;
    font-weight: 700;
    font-size: 22px;
    line-height: 120%;
  }
  .selected_tokens {
    width: 80%;
    margin: 0px auto;
    display: flex;
    justify-content: space-around;
    div {
      display: flex;
      width: 135px;
      align-items: center;
      box-shadow: 0.9px 0.9px 1.3px rgba(0, 0, 0, 0.25);
      border-radius: 3.79093px;
      padding: 10px;
      img {
        width: 32px;
        margin: 0px 10px;
      }
      h3 {
        margin: 0;
        padding: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
`;

export const NoPoolFound = ({ token1, token2, createPool }) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = React.useState(false);

  const handleCloseModal = () => {
    setIsCreateModalOpen(false);
  };

  const handleCreate = async () => {
    await createPool(token1, token2);
  };

  const handleOpenModal = () => {
    if (token1.symbol && token2.symbol) {
      setIsCreateModalOpen(true);
    } else {
      alert('Please select two tokens');
    }
  };

  return (
    <>
      <NoPoolContainer>
        <div className='no_pool_component'>
          <h1>No Pool Found</h1>
          <p>
            With Market, you can maximize your yield, contribute to risk
            management and create unparalleled opportunities to make the most of
            DeFi.
          </p>

          <Button style={{backgroundColor:"#aaaaaa", border:"none"}} disabled onClick={handleOpenModal} className='style-active'>
            Create Pool Coming Soon
          </Button>
        </div>
      </NoPoolContainer>
      {isCreateModalOpen && (
        <Modal
          className='antd_modal_overlay'
          visible={isCreateModalOpen}
          centered
          onCancel={handleCloseModal}
          footer={null}
          closable={false}
        >
          <CreatePoolModal>
            <h1>Create New Pool</h1>
            <div className='selected_tokens'>
              <div>
                <img src={token1.logoURI} alt='logo' />
                <h3>{token1.symbol}</h3>
              </div>
              <div>
                <img src={token2.logoURI} alt='logo' />
                <h3>{token2.symbol}</h3>
              </div>
            </div>
            <Button onClick={handleCreate} className='style-active'>
              Create pool
            </Button>
          </CreatePoolModal>
        </Modal>
      )}
    </>
  );
};
